<div class="main-container">
  <div class="img-container">
    <img src="/assets/images/logos/us_eu/InsureShield_vertical_UPSCIA.png" alt="InsureShield" srcset="" height="150px">
  </div>
  <div class="text-center">
    <p style="font-size: larger;">Signing Completed Successfully! 🎉</p>
    <p style="font-size: small;">This tab will close automatically in <span class="font-weight-bold">{{countdown}}</span>.</p>
    <p style="font-size: x-small;">If this window doesn't close, click the button below</p>
    <button type="button" class="btn btn-outline-dark" (click)="closeWindow()" [disabled]="!isCompleted">Close</button>
  </div>
</div>